import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../access/auth.service";
import { CategoryV2Dto, ParentCategoryDto } from "../../models/category.v2";
import { CategoryV2Service } from "../../pages/members/category-v2/services/category.v2.service";

@Component({
    selector: 'app-category-tree-specifications',
    templateUrl: './category-tree.specifications.component.html',
    styleUrls: ['./category-tree.specifications.component.scss']
})
export class CategoryTreeSpecificationsComponent {
    @Input() list: ParentCategoryDto[] | undefined;
    @Input() category: CategoryV2Dto = new CategoryV2Dto;
    @Input() level: number = 1;
    @Input() onExport?: (id: string) => void;
    @Output() addCategoryEvent: EventEmitter<any> = new EventEmitter();
    @Output() editCategoryEvent: EventEmitter<any> = new EventEmitter();
    @Output() deleteCategoryEvent: EventEmitter<any> = new EventEmitter();

    expandedMap: { [id: string]: boolean } = {};
    childrenMap: { [id: string]: ParentCategoryDto[] } = {};

    constructor(
        private _service: CategoryV2Service,
        private _auth: AuthService,
        private router: Router
    ) { }
    ngOnInit() {
        this._service.get(this._auth.getStore().storeId, this.category.id).subscribe({
            next: (res) => {
              this.category = res;
            }
          });
    }
    viewSpecs(categoryId: string): void {
      this.router.navigate(['/members/specifications/listSpecifications'], {
        queryParams: { categoryId }
      });
    }
    
    getSubs(category: ParentCategoryDto): void {
        const isExpanded = this.expandedMap[category.id];
    
        if (isExpanded) {
          this.expandedMap[category.id] = false; 
        } else {
          this.expandedMap[category.id] = true; 
    
          if (!this.childrenMap[category.id]) {
            this._service.get(this._auth.getStore().storeId, category.id).subscribe({
              next: (res) => {
                this.childrenMap[category.id] = res.children;
              }
            });
          }
        }
      }

    deleteCategory(category: ParentCategoryDto) {
        this.deleteCategoryEvent.emit(category);
    }

    addCategory(category: ParentCategoryDto) {
        this.addCategoryEvent.emit(category);
    }

    editCategory(category: ParentCategoryDto) {
        this.editCategoryEvent.emit(category);
    }
}